import { twMerge } from "tailwind-merge";
import { IconCross } from "../../icons/IconCross";

export default function ActiveFilterItemIndicator({
  label,
  value,
  onRemove,
  className,
}: {
  label: string;
  value: string;
  onRemove: () => void;
  className?: string;
}) {
  return (
    <span
      className={twMerge(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200",
        className
      )}
    >
      {label}:&nbsp;<strong>{value}</strong>
      <button onClick={onRemove} className="ml-1 inline-flex items-center">
        <IconCross className="size-3 hover:text-black dark:hover:text-white" />
      </button>
    </span>
  );
}
